<h1 class="text-center border-bottom pb-3">Zending info</h1>

<form
  class="row pt-3"
  [formGroup]="form"
  (ngSubmit)="search()"
>
  <div class="col-12 col-md-6 col-lg-4">
    <div class="input-group has-validation">
      <div class="form-floating">
        <input
          type="text"
          class="form-control"
          id="shipmentInfoOrderNumber"
          placeholder="INDI ordernummer"
          formControlName="orderNumber"
          [class.is-invalid]="orderNumber.invalid && (orderNumber.dirty || orderNumber.touched)"
        />
        <label for="shipmentInfoOrderNumber">INDI ordernummer</label>
      </div>
      <button
        class="btn btn-outline-primary search-button"
        type="submit"
        [disabled]="orderNumber.invalid || isLoading"
        title="Zoeken"
        aria-label="Zoeken"
      >
        <i
          class="fa-solid fa-magnifying-glass"
          aria-hidden="true"
        ></i>
      </button>
      <div
        class="invalid-feedback order-number-error"
        *ngIf="orderNumber.invalid && (orderNumber.dirty || orderNumber.touched)"
      >
        <span *ngIf="orderNumber.errors?.['required']">Ordernummer is verplicht.</span>
        <span *ngIf="orderNumber.errors?.['pattern']">Ordernummer moet een INDI ordernummer zijn.</span>
      </div>
    </div>
  </div>
</form>

<div
  *ngIf="isLoading"
  class="loading"
>
  <app-loading-gears></app-loading-gears>
</div>

<div
  *ngIf="errorMessage"
  class="alert alert-danger mt-3 error-message"
  role="alert"
>
  {{ errorMessage }}
</div>

<div
  *ngIf="info"
  class="mt-4 shipment-info"
>
  <div class="d-flex flex-wrap align-items-center gap-4 mb-3 order-header">
    <div>
      <div class="text-muted small">INDI ordernummer</div>
      <div class="fs-5 fw-bold order-number">{{ info.orderNumber }}</div>
    </div>
    <div>
      <div class="text-muted small">Klantnummer</div>
      <div class="fs-5 fw-bold customer-number">{{ info.customerNumber }}</div>
    </div>
    <button
      type="button"
      class="btn btn-outline-primary ms-auto copy-all"
      [copyToClipboard]="copyAll"
    >
      <i
        class="fa-regular fa-copy me-1"
        aria-hidden="true"
      ></i
      >Kopieer alles
    </button>
  </div>

  <div
    *ngFor="let view of krampOrders"
    class="card mb-3 kramp-order"
  >
    <div class="card-header fw-bold kramp-order-number">
      <ng-container *ngIf="view.krampOrder.krampOrderNumber; else unknownKrampOrder">
        Kramp ordernummer {{ view.krampOrder.krampOrderNumber }}
      </ng-container>
      <ng-template #unknownKrampOrder>Onbekend Kramp ordernummer</ng-template>
    </div>
    <div class="card-body">
      <div
        *ngIf="view.krampOrder.deliveryAddress as address"
        class="mb-3 delivery-address"
      >
        <div class="text-muted small">Afleveradres</div>
        <div>{{ address.address }}</div>
        <div>{{ address.postalCode }} {{ address.city }}</div>
      </div>

      <div
        *ngIf="shipTo"
        class="mb-3 ship-to"
      >
        <div class="text-muted small">{{ shipToNoLabel }}</div>
        <div
          *ngIf="shipTo.state === 'loading'"
          class="text-muted ship-to-loading"
        >
          <span
            class="spinner-border spinner-border-sm me-2"
            aria-hidden="true"
          ></span
          >Ophalen...
        </div>
        <div
          *ngIf="shipTo.state === 'none'"
          class="ship-to-none"
        >
          Geen
        </div>
        <div
          *ngIf="shipTo.state === 'error'"
          class="text-danger ship-to-error"
        >
          {{ shipToNoLabel }} kon niet worden opgehaald
        </div>
        <ng-container *ngIf="shipToAddress">
          <div class="d-flex align-items-center gap-2">
            <span class="ship-to-line">{{ shipToLine }}</span>
            <button
              type="button"
              class="btn btn-sm btn-link p-0 ms-1 copy-ship-to"
              title="Kopieer {{ shipToNoLabel }}"
              attr.aria-label="Kopieer {{ shipToNoLabel }}"
              [copyToClipboard]="shipToCopy"
            >
              <i
                class="fa-regular fa-copy"
                aria-hidden="true"
              ></i>
            </button>
          </div>
          <div
            *ngIf="view.shipToDiffers"
            class="small text-warning-emphasis ship-to-mismatch"
          >
            Wijkt af van het afleveradres
          </div>
        </ng-container>
      </div>

      <p
        *ngIf="view.noShipmentInfo"
        class="fst-italic mb-0 no-shipment-info"
      >
        {{ noShipmentInfo }}
      </p>

      <div
        *ngFor="let packageView of view.packages"
        class="border-top pt-2 mt-2 package"
      >
        <div class="d-flex align-items-center gap-2 mb-2">
          <span class="badge text-bg-secondary carrier">{{ packageView.carrierName }}</span>
          <a
            *ngIf="packageView.shipmentPackage.trackingUrl; else barcodeWithoutLink"
            class="barcode"
            [href]="packageView.shipmentPackage.trackingUrl"
            target="_blank"
            rel="noopener"
            >{{ packageView.shipmentPackage.barcode }}</a
          >
          <ng-template #barcodeWithoutLink>
            <span class="barcode">{{ packageView.shipmentPackage.barcode }}</span>
          </ng-template>
          <button
            type="button"
            class="btn btn-sm btn-link p-0 ms-1 copy-package"
            title="Kopieer pakket"
            attr.aria-label="Kopieer pakket {{ packageView.shipmentPackage.barcode }}"
            [copyToClipboard]="packageView.copy"
          >
            <i
              class="fa-regular fa-copy"
              aria-hidden="true"
            ></i>
          </button>
        </div>
        <div
          *ngIf="packageView.nse as nse"
          class="mb-2 nse-status"
        >
          <span class="text-muted me-1">Status NSE:</span>
          <span
            *ngIf="nse.state === 'loading'"
            class="text-muted nse-loading"
          >
            <span
              class="spinner-border spinner-border-sm me-2"
              aria-hidden="true"
            ></span
            >Ophalen...
          </span>
          <span
            *ngIf="nse.state === 'error'"
            class="text-danger nse-error"
            >Status kon niet worden opgehaald</span
          >
          <ng-container *ngIf="nse.state === 'found'">
            <a
              *ngIf="packageView.nseText && nse.nseStatus.mapsUrl; else nseWithoutLink"
              class="nse-scan"
              [href]="nse.nseStatus.mapsUrl"
              target="_blank"
              rel="noopener"
              >{{ packageView.nseText }}</a
            >
            <ng-template #nseWithoutLink>
              <span class="nse-scan">{{ packageView.nseText ?? 'Nog geen scans bij NSE' }}</span>
            </ng-template>
          </ng-container>
        </div>
        <table
          *ngIf="packageView.shipmentPackage.contents.length"
          class="table table-sm table-bordered mb-0 package-contents"
        >
          <colgroup>
            <col class="sku-column" />
            <col />
            <col class="quantity-column" />
          </colgroup>
          <thead>
            <tr>
              <th scope="col">SKU</th>
              <th scope="col">Omschrijving</th>
              <th
                scope="col"
                class="text-end"
              >
                Aantal
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let line of packageView.shipmentPackage.contents">
              <td>{{ line.sku }}</td>
              <td>{{ line.description }}</td>
              <td class="text-end">{{ line.quantity | number: '1.0-3' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        *ngIf="view.unpackedLines.length"
        class="border-top pt-2 mt-2 unpacked-lines"
      >
        <div class="fw-bold mb-2">{{ unpackedLinesTitle }}</div>
        <table class="table table-sm table-bordered mb-0 package-contents">
          <colgroup>
            <col class="sku-column" />
            <col />
            <col class="quantity-column" />
            <col class="status-column" />
          </colgroup>
          <thead>
            <tr>
              <th scope="col">SKU</th>
              <th scope="col">Omschrijving</th>
              <th
                scope="col"
                class="text-end"
              >
                Aantal
              </th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let unpacked of view.unpackedLines">
              <td>{{ unpacked.line.sku }}</td>
              <td>{{ unpacked.line.description }}</td>
              <td class="text-end">{{ unpacked.line.quantity | number: '1.0-3' }}</td>
              <td class="unpacked-status">{{ unpacked.status }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
